import React from 'react'

const ConfirmContext = React.createContext<any | null>(null)

export default ConfirmContext
